import type { SerializedRichText } from '@/client/services/richText/types'

import SHWError from './SHWError'

type UserErrorType = 'content-outdated' | 'validation' | 'rate-limit' | 'concurrency-limit'

const MESSAGE_RATE_LIMIT_REACHED = 'Woah! You are doing this too often. Please try again later'

const MESSAGE_GLOBAL_LOCK_FAILED = 'Woah! This is happening too often. Please try again later'

const CODE_TO_EXTERNAL_MESSAGE: Record<UserErrorType, string> = {
  'content-outdated': 'This content is outdated. Please refresh your page and try again.',
  validation: 'Invalid input. Please try again.',
  'rate-limit': MESSAGE_RATE_LIMIT_REACHED,
  'concurrency-limit': MESSAGE_GLOBAL_LOCK_FAILED,
}

// UserErrors are errors that are possible to hit through our UI (eg hitting a
// rate limiting, failing validation that must be done server-side, etc). They
// can be hit even in bug-free code, so they don't always require a fix.
export default class UserError extends SHWError {
  type: UserErrorType

  constructor(args: {
    externalMessage?: string | SerializedRichText
    internalMessage?: string
    type: UserErrorType
  }) {
    const externalMessage = args.externalMessage ?? CODE_TO_EXTERNAL_MESSAGE[args.type]
    super({ externalMessage, internalMessage: args.internalMessage })
    this.type = args.type
  }
}
